{
  "name": "redtrust",
  "version": "4.50.2",
  "scripts": {
    "serve": "ng serve -o --ssl --port=4201 --project=%npm_package_name%",
    "build": "rimraf dist && ng build %npm_package_name%",
    "build:dev": "npm run build -- --project %npm_package_name% --configuration dev",
    "start:fakeapi": "nodemon src/json-server-api/server.js --watch src/json-server-api/*.*",
    "start:web-client": "npm run serve -- --configuration dev",
    "start:mobile": "npm run serve -- --configuration mobile",
    "start:web-dev": "concurrently \"npm run start:fakeapi\" \"npm run start:web-client\"",
    "build:backend": "npm run build -- --project %npm_package_name% --configuration backend",
    "start:web-backend": "npm run serve -- --configuration backend",
    "build:server": "npm run build -- --project %npm_package_name% --configuration server",
    "start:web-server": "npm run serve -- --configuration server",
    "build:prod": "npm run build -- --project %npm_package_name% --configuration production",
    "open:xcode": "npx cap open ios",
    "create:ios": "npx cap add ios",
    "mobile:ios-assets": "npx capacitor-assets generate --assetPath ./src/assets/images/mobile/%npm_package_name% --ios",
    "mobile:ios-trapeze": "npx trapeze run trapeze.yaml --ios-project ios/App -y",
    "build:ios": "rimraf ./ios && npm run create:ios && npm run build -- --project %npm_package_name% --configuration mobile && npx cap sync ios && npm run mobile:ios-assets && npm run mobile:ios-trapeze",
    "start:ios-client": "npx cap run ios -l --ssl",
    "start:ios": "npm run build:ios && npm run start:ios-client",
    "open:android-studio": "npx cap open android",
    "create:android": "npx cap add android",
    "mobile:android-assets": "npx capacitor-assets generate --assetPath ./src/assets/images/mobile/%npm_package_name% --android ",
    "mobile:android-trapeze": "npx trapeze run trapeze.yaml --android-project android -y",
    "build:android": "npm run build -- --project %npm_package_name% --configuration mobile && rimraf ./android && npm run create:android && npx cap sync android && npm run mobile:android-assets && npm run mobile:android-trapeze",
    "start:android-client": "npx cap run android -l --ssl",
    "start:android": "npm run build:android && npm run start:android-client",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.1.5",
    "@angular/cdk": "19.1.3",
    "@angular/common": "19.1.5",
    "@angular/compiler": "19.1.5",
    "@angular/core": "19.1.5",
    "@angular/forms": "19.1.5",
    "@angular/material": "19.1.3",
    "@angular/material-moment-adapter": "19.1.3",
    "@angular/platform-browser": "19.1.5",
    "@angular/platform-browser-dynamic": "19.1.5",
    "@angular/router": "19.1.5",
    "@azure/msal-angular": "3.0.4",
    "@azure/msal-browser": "3.1.0",
    "@capacitor/android": "5.5.1",
    "@capacitor/app": "5.0.6",
    "@capacitor/assets": "3.0.1",
    "@capacitor/core": "5.5.1",
    "@capacitor/filesystem": "5.1.4",
    "@capacitor/ios": "5.5.1",
    "@capacitor/keyboard": "5.0.6",
    "@capacitor/share": "5.0.6",
    "@capgo/inappbrowser": "1.4.4",
    "@juggle/resize-observer": "3.4.0",
    "@microsoft/microsoft-graph-client": "3.0.7",
    "@ncstate/sat-popover": "10.3.2",
    "@ngx-translate/core": "14.0.0",
    "@ngx-translate/http-loader": "7.0.0",
    "@trapezedev/configure": "7.0.0",
    "bootstrap": "5.3.3",
    "cross-fetch": "4.1.0",
    "date-fns": "2.30.0",
    "file-saver": "2.0.5",
    "html2canvas": "1.4.1",
    "jquery": "3.7.0",
    "js-htmlencode": "0.3.0",
    "material-design-icons": "3.0.1",
    "moment": "2.29.4",
    "ngx-drag-drop": "19.0.0",
    "ngx-material-timepicker": "13.1.1",
    "ngx-toastr": "16.2.0",
    "npm": "11.1.0",
    "pdfjs-dist": "4.10.38",
    "rxjs": "7.5.0",
    "sha.js": "2.4.11",
    "ts-md5": "1.3.1",
    "tslib": "2.6.2",
    "uuid": "8.3.2",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.6",
    "@angular/cli": "19.1.6",
    "@angular/compiler-cli": "19.1.5",
    "@angular/language-service": "19.1.5",
    "@capacitor/cli": "5.5.1",
    "@fortawesome/fontawesome-free": "5.15.4",
    "@microsoft/microsoft-graph-types": "2.43.1",
    "@types/file-saver": "2.0.5",
    "@types/jasmine": "3.10.11",
    "@types/jasminewd2": "2.0.10",
    "@types/node": "22.13.10",
    "concurrently": "7.6.0",
    "cross-var": "1.1.0",
    "jasmine-core": "3.99.1",
    "jasmine-spec-reporter": "5.0.2",
    "json-server": "0.17.1",
    "karma": "6.4.2",
    "karma-chrome-launcher": "3.2.0",
    "karma-cli": "2.0.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "4.0.2",
    "karma-jasmine-html-reporter": "1.7.0",
    "karma-mocha-reporter": "2.2.5",
    "ng-packagr": "19.1.2",
    "nodemon": "2.0.20",
    "prettier": "2.8.8",
    "rimraf": "3.0.2",
    "semantic-release": "21.0.6",
    "source-map-explorer": "2.5.3",
    "ts-node": "8.10.2",
    "typescript": "5.7.3"
  },
  "overrides": {
    "@napi-rs/canvas": "0.1.70"
  }
}
